import { computed } from 'vue';

import { getAppUrl } from '@/helpers/url';

export default function useCheckoutHelpers(root) {
  const rootGetters = root.$store.getters;

  const hasAvailability = computed(() => rootGetters['quote/hasAvailability']);
  const hasQuote = computed(() => rootGetters['quote/hasQuote']);
  const getAppointmentFee = computed(() => rootGetters['quote/getQuoteAppointmentFee']?.amount?.amount);
  const canPurchaseSubscriptionPlan = computed(() => rootGetters['subscriptions/canPurchaseSubscriptionPlan']);
  const subsPayGoPerks = computed(() => root.$statsig.ready && root.$statsig.getDynamicConfig('subs_payg_perks')?.value?.[rootGetters.getSiteLocale]);

  const isSearchUuidParameterIgnored = computed(() => root.$statsig.ready && root.$statsig.checkGate('search_hide_search_uuid'));

  const isSubscription = computed(() => root.$statsig.ready && root.$statsig.checkGate('booking_user_vcpr_eligible') && canPurchaseSubscriptionPlan.value);

  const getBookingUrl = (quote) => getAppUrl(`/cx/booking/${quote.uuid}`);

  const getPriceCap = () => {
    const priceCapDefault = 10000;

    if (root.$statsig.ready) {
      const priceCapConfig = root.$statsig.getDynamicConfig('subs_price_gating')?.value;
      const priceCap = priceCapConfig?.guardrails?.find((guardrail) => guardrail.program === 'Vetster Plus')?.booking;

      return priceCap ?? priceCapDefault;
    }

    return priceCapDefault;
  };

  const showPaymentOption = computed(() => !!(canPurchaseSubscriptionPlan.value
    && hasAvailability.value
    && hasQuote.value
    && getAppointmentFee.value < getPriceCap()));

  return {
    getBookingUrl,
    isSearchUuidParameterIgnored,
    isSubscription,
    showPaymentOption,
    subsPayGoPerks,
  };
}
